/**
 * Mini Cart Price Mover
 * Moves price containers into title/variant/discount/error containers
 */

(function() {
  'use strict';

  // Function to move price containers
  function movePriceContainers() {
    const products = document.querySelectorAll('.fcsb-mini-cart-product-container-grid');
    let movedCount = 0;
    
    products.forEach(product => {
      const priceContainer = product.querySelector('.fcsb-price-container');
      const titleContainer = product.querySelector('.fcsb-title-variant-discount-error');
      
      if (priceContainer && titleContainer) {
        // Check if price container is not already inside title container
        if (!titleContainer.contains(priceContainer)) {
          titleContainer.appendChild(priceContainer);
          movedCount++;
        }
      }
    });
    
    if (movedCount > 0) {
      // Price containers moved successfully
    }
  }

  // Function to remove parentheses from quantity elements
  function removeQuantityParentheses() {
    const quantityElements = document.querySelectorAll('.fcsb-quantity');
    let cleanedCount = 0;

    quantityElements.forEach(element => {
      const originalText = element.textContent;
      const cleanedText = originalText.replace(/[()]/g, '');
      
      if (originalText !== cleanedText) {
        element.textContent = cleanedText;
        cleanedCount++;
      }
    });

    if (cleanedCount > 0) {
      // Quantity elements cleaned successfully
    }
  }

  // Function to add shopping cart icon to title elements (scoped to mini cart)
  function addCartIcons() {
    const miniCartTitle = document.querySelector('.fcsb-mini-cart-title');
    if (!miniCartTitle) return;
    
    const titleElements = miniCartTitle.querySelectorAll('.fcsb-title');
    let iconsAdded = 0;

    titleElements.forEach(element => {
      // Check if icon already exists
      if (!element.querySelector('.cart-title-icon')) {
        const iconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shopping-cart w-5 h-5 text-[#C70751] cart-title-icon"><circle cx="8" cy="21" r="1"></circle><circle cx="19" cy="21" r="1"></circle><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path></svg>`;
        element.insertAdjacentHTML('afterbegin', iconSvg);
        iconsAdded++;
      }
    });

    if (iconsAdded > 0) {
      // Cart icons added successfully
    }
  }

  // Function to replace close button content with icon (scoped to mini cart)
  function addCloseIcons() {
    const miniCartTitle = document.querySelector('.fcsb-mini-cart-title');
    if (!miniCartTitle) return;
    
    const closeButtons = miniCartTitle.querySelectorAll('.fcsb-close-button');
    let iconsAdded = 0;

    closeButtons.forEach(element => {
      // Check if content hasn't been replaced yet
      if (!element.querySelector('.close-button-icon')) {
        const iconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x h-4 w-4 close-button-icon"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>`;
        element.innerHTML = iconSvg;
        iconsAdded++;
      }
    });

    if (iconsAdded > 0) {
      // Close button contents replaced successfully
    }
  }

  function parseMoneyString(value) {
    if (!value)
      return NaN;

    const normalized = value.replace(/[^\d.,-]/g, '').trim();
    if (!normalized)
      return NaN;

    const lastComma = normalized.lastIndexOf(',');
    const lastDot = normalized.lastIndexOf('.');
    const hasComma = lastComma !== -1;
    const hasDot = lastDot !== -1;

    if (hasComma && hasDot) {
      if (lastDot > lastComma)
        return parseFloat(normalized.replace(/,/g, ''));
      return parseFloat(normalized.replace(/\./g, '').replace(',', '.'));
    }

    if (hasComma && !hasDot) {
      if ((normalized.match(/,/g) || []).length === 1)
        return parseFloat(normalized.replace(',', '.'));
      return parseFloat(normalized.replace(/,/g, ''));
    }

    return parseFloat(normalized);
  }

  function parsePriceValue(element) {
    if (!element)
      return NaN;

    const textValue = parseMoneyString(element.textContent || '');
    if (!Number.isNaN(textValue))
      return textValue;

    if (element.innerHTML) {
      const htmlStripped = element.innerHTML.replace(/<[^>]*>/g, '');
      const htmlValue = parseMoneyString(htmlStripped);
      if (!Number.isNaN(htmlValue))
        return htmlValue;
    }

    if (element.dataset) {
      const datasetCandidates = [
        element.dataset.price,
        element.dataset.value,
        element.dataset.amount
      ];
      for (const candidate of datasetCandidates) {
        if (!candidate)
          continue;
        const cleaned = candidate.replace(/[^\d.-]/g, '');
        if (!cleaned)
          continue;
        const numeric = Number(cleaned);
        if (Number.isNaN(numeric))
          continue;
        if (!candidate.includes('.') && !candidate.includes(','))
          return numeric / 100;
        return numeric;
      }
    }

    return NaN;
  }

  function extractCurrencySymbol(element) {
    if (!element)
      return '$';
    const matches = (element.textContent || '').match(/[^0-9.,\s-]+/g);
    if (!matches || !matches.length)
      return '$';
    return matches[matches.length - 1];
  }

  // Function to calculate and display savings
  function addSavingsDisplay() {
    const products = document.querySelectorAll('.fcsb-mini-cart-product-container-grid');
    products.forEach(product => {
      const priceContainer = product.querySelector('.fcsb-price-container');
      if (!priceContainer) return;

      const currentPrice = priceContainer.querySelector('.fcsb-price');
      const originalPrice = priceContainer.querySelector('.fcsb-original-price');

      const existingSavings = product.querySelector('.savings-display');

      if (currentPrice && originalPrice) {
        const currentPriceValue = parsePriceValue(currentPrice);
        const originalPriceValue = parsePriceValue(originalPrice);

        if (!Number.isNaN(currentPriceValue) && !Number.isNaN(originalPriceValue) && originalPriceValue > currentPriceValue) {
          const savings = originalPriceValue - currentPriceValue;
          const percentOff = Math.round((savings / originalPriceValue) * 100);
          const currencySymbol = extractCurrencySymbol(currentPrice);
          const currencySpacing = currencySymbol.length > 1 ? ' ' : '';

          let savingsElement = existingSavings;
          if (!savingsElement) {
            savingsElement = document.createElement('div');
            savingsElement.className = 'savings-display';
            savingsElement.style.fontSize = '12px';
            savingsElement.style.color = '#16a34a';
            savingsElement.style.fontWeight = '500';
            savingsElement.style.marginTop = '4px';
          }

          savingsElement.textContent = `Save ${percentOff}% Off`;

          if (priceContainer.nextElementSibling !== savingsElement)
            priceContainer.insertAdjacentElement('afterend', savingsElement);
          return;
        }
      }

      if (existingSavings)
        existingSavings.remove();
    });
  }

  // Function to hide bundled installation line items in FCSB cart
  function hideInstallationItems() {
    const products = document.querySelectorAll('.fcsb-mini-cart-product-container-grid');
    products.forEach(product => {
      // Find ALL links and text in this product row
      const allLinks = product.querySelectorAll('a[href]');
      const allText = (product.textContent || '').toLowerCase();

      let isInstallProduct = false;

      // Check links for installation product URL
      allLinks.forEach(link => {
        const href = (link.getAttribute('href') || '').toLowerCase();
        if (href.includes('installation-package-outdoor-kitchen')) {
          isInstallProduct = true;
        }
      });

      // Also check by exact title match as fallback
      if (!isInstallProduct && allText.includes('installation package - outdoor kitchen')) {
        isInstallProduct = true;
      }

      if (isInstallProduct) {
        const row = product.closest('.fcsb-mini-cart-product-container') || product;
        row.style.display = 'none';
      }
    });
  }

  // Function to add install note to outdoor kitchen items in FCSB cart
  function addInstallNoteToKitchen() {
    const products = document.querySelectorAll('.fcsb-mini-cart-product-container-grid');
    products.forEach(product => {
      // Skip if already has install note
      if (product.querySelector('.fcsb-install-note')) return;

      // Skip if this is the hidden installation product
      const allText = (product.textContent || '').toLowerCase();
      if (allText.includes('installation package - outdoor kitchen')) return;

      // Check links for the Zurich or other outdoor kitchen products
      const allLinks = product.querySelectorAll('a[href]');
      let isKitchenProduct = false;

      allLinks.forEach(link => {
        const href = (link.getAttribute('href') || '').toLowerCase();
        if (href.includes('euro-alfresco')) {
          isKitchenProduct = true;
        }
      });

      if (!isKitchenProduct) return;

      const titleContainer = product.querySelector('.fcsb-title-variant-discount-error') || product.querySelector('.fcsb-title');
      if (!titleContainer) return;

      const note = document.createElement('div');
      note.className = 'fcsb-install-note';
      note.style.cssText = 'display:inline-flex;align-items:center;gap:4px;color:#0D9488;font-size:12px;font-weight:500;margin-top:4px;';
      note.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg> Incl. Check, Measure &amp; Install ($1,450)';
      titleContainer.appendChild(note);
    });
  }

  // Function to sync installation product — remove it if the kitchen is no longer in cart
  //
  // Throttled to once per 5 seconds to avoid contributing to Shopify /cart.js rate limits
  // (storefront rate limit kicks in around 40 req/min/IP; with this script wired to a
  // MutationObserver that fires on every cart-sidebar DOM change plus Shopify's own pixel
  // also polling /cart.js, we were hitting 429s and breaking remove-from-cart). 429
  // responses now retry with backoff instead of throwing JSON parse errors.
  var lastSyncAt = 0;
  var SYNC_MIN_INTERVAL_MS = 5000;

  function syncInstallationWithKitchen() {
    var now = Date.now();
    if (now - lastSyncAt < SYNC_MIN_INTERVAL_MS) return; // throttle
    lastSyncAt = now;

    fetchCartJsonWithBackoff(0)
      .then(function (cart) {
        if (!cart) return; // 429 even after retries — give up quietly
        var hasKitchen = false;
        var installLineKey = null;

        cart.items.forEach(function (item) {
          // Check if any item is an install-required kitchen product
          if (item.handle && item.handle.includes('euro-alfresco')) {
            hasKitchen = true;
          }
          // Find the installation line item
          if (item.handle === 'installation-package-outdoor-kitchen') {
            installLineKey = item.key;
          }
        });

        // If no kitchen but installation exists, remove it
        if (!hasKitchen && installLineKey) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: installLineKey, quantity: 0 })
          }).then(function () {
            console.log('[InstallBundle] Removed orphaned installation from cart');
            // Trigger cart UI refresh
            if (window.__scheduleMiniCartEnhancements) {
              window.__scheduleMiniCartEnhancements(300);
            }
          });
        }
      });
  }

  // Helper: fetch /cart.js with retry-on-429 backoff. Returns cart object or null on
  // permanent failure. Doesn't throw on parse errors when Shopify returns its HTML
  // rate-limit page.
  function fetchCartJsonWithBackoff(attempt) {
    return fetch('/cart.js')
      .then(function (r) {
        if (r.status === 429) {
          if (attempt >= 2) return null; // give up after 3 attempts
          var delay = 1500 * Math.pow(2, attempt); // 1.5s, 3s, 6s
          return new Promise(function (resolve) {
            setTimeout(function () {
              resolve(fetchCartJsonWithBackoff(attempt + 1));
            }, delay);
          });
        }
        return r.json().catch(function () { return null; });
      })
      .catch(function () { return null; });
  }

  // Function to update empty cart content
  function updateEmptyCartContent() {
    const emptyCartElement = document.querySelector('.fcsb-mini-cart-empty');
    if (!emptyCartElement) return;

    // Check if we already updated the content
    if (emptyCartElement.querySelector('.custom-empty-cart')) return;

    const newContent = `
      <div class="custom-empty-cart">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="8" cy="21" r="1"></circle><circle cx="19" cy="21" r="1"></circle>
          <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
        </svg>
        <h4>Your cart is empty</h4>
        <p>Add some products to get started.</p>
      </div>
    `;

    emptyCartElement.innerHTML = newContent;
  }

  // Initialize when DOM is ready
  function init() {
    const runEnhancements = () => {
      movePriceContainers();
      removeQuantityParentheses();
      addCartIcons();
      addCloseIcons();
      addSavingsDisplay();
      hideInstallationItems();
      addInstallNoteToKitchen();
      syncInstallationWithKitchen();
      updateEmptyCartContent();
      initCheckoutButton();
    };

    let enhancementScheduled = false;
    const scheduleEnhancements = (delay = 0) => {
      if (enhancementScheduled)
        return;
      enhancementScheduled = true;

      const execute = () => {
        enhancementScheduled = false;
        runEnhancements();
      };

      if (delay > 0) {
        setTimeout(execute, delay);
      } else if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(execute);
      } else {
        setTimeout(execute, 16);
      }
    };

    runEnhancements();
    scheduleEnhancements(2000);

    const miniCartSidebar = document.querySelector('.fcsb-mini-cart-sidebar');
    
    if (miniCartSidebar) {
      const observer = new MutationObserver(() => {
        scheduleEnhancements();
      });

      observer.observe(miniCartSidebar, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });

      document.addEventListener('fcsb:cart:updated', scheduleEnhancements);
      document.addEventListener('fcsb:cart:item-removed', scheduleEnhancements);
      document.addEventListener('fcsb:cart:quantity-changed', scheduleEnhancements);
    } else {
      // Retry after a delay if mini cart isn't loaded yet
      setTimeout(init, 1000);
    }

    window.__scheduleMiniCartEnhancements = scheduleEnhancements;
  }

  // Function to handle checkout button click
  function initCheckoutButton() {
    const checkoutButton = document.querySelector('.fcsb-checkout');
    if (!checkoutButton) return;

    // Avoid adding multiple listeners
    if (checkoutButton.dataset.listenerAdded) return;
    checkoutButton.dataset.listenerAdded = 'true';

    checkoutButton.addEventListener('click', function() {
      const span = this.querySelector('span');
      const originalText = span ? span.textContent : 'Go To Checkout';
      const originalBg = this.style.backgroundColor;

      // Change to loading state
      this.style.backgroundColor = '#15803d';
      if (span) {
        span.textContent = 'Please wait...';
      }

      // Reset after 5 seconds
      setTimeout(() => {
        this.style.backgroundColor = originalBg || '';
        if (span) {
          span.textContent = originalText;
        }
      }, 5000);
    });
  }

  // Global functions for manual triggering
  window.moveMiniCartPrices = movePriceContainers;
  window.removeQuantityParentheses = removeQuantityParentheses;
  window.addCartIcons = addCartIcons;
  window.addCloseIcons = addCloseIcons;
  window.addSavingsDisplay = addSavingsDisplay;
  window.updateEmptyCartContent = updateEmptyCartContent;
  window.initCheckoutButton = initCheckoutButton;

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
